import { sanitizeLabelMap } from '../utilities/sanitizeLabelMarkup';

const STRIP_INVALID_PRICING_ELEMENTS =
	'ws-inv-listing-strip-invalid-pricing-elements';
const ADD_LABELS = 'WS_SCRIPTS_ADD_LABELS';
const SET_FLAGS = 'WS_SCRIPTS_SET_FEATURE_FLAGS';

const sanitizeLabels = (store) => (next) => (action) => {
	if (!action || action.error || action.payload === undefined) {
		return next(action);
	}

	if (action.type === ADD_LABELS) {
		return store.getState()?.flags?.[STRIP_INVALID_PRICING_ELEMENTS]
			? next({ ...action, payload: sanitizeLabelMap(action.payload) })
			: next(action);
	}

	if (action.type === SET_FLAGS) {
		const result = next(action);

		if (action.payload[STRIP_INVALID_PRICING_ELEMENTS]) {
			const { labels } = store.getState() || {};

			if (labels && Object.keys(labels).length) {
				store.dispatch({
					type: ADD_LABELS,
					payload: sanitizeLabelMap(labels)
				});
			}
		}

		return result;
	}

	return next(action);
};

export default [sanitizeLabels];
